import { DocumentType } from '@/shared/lib';

export interface VerificationDetailConfig {
  cardTitle: string;
  codeFieldLabel: string;
  usesRegistrationCard: boolean;
  viewButtonLabel: string;
  approveOptionLabel: string;
  rejectOptionLabel: string;
  hasTrainingStep: boolean;
  requiresRejectionJustification: boolean;
  rejectPlaceholder: string;
  rejectConfirmTitle: string;
  rejectSuccessTitle: string;
  rejectErrorMessage: string;
  listTabType: DocumentType;
}

export const VERIFICATION_DETAIL_CONFIG: Record<DocumentType, VerificationDetailConfig> = {
  [DocumentType.DOCUMENT]: {
    cardTitle: 'Documento para Verificação',
    codeFieldLabel: 'Documento',
    usesRegistrationCard: false,
    viewButtonLabel: 'Ver documento',
    approveOptionLabel: 'Aprovar documento',
    rejectOptionLabel: 'Reprovar documento',
    hasTrainingStep: true,
    requiresRejectionJustification: true,
    rejectPlaceholder: 'Explique porque o documento foi reprovado',
    rejectConfirmTitle: 'Tem certeza que deseja reprovar o documento?',
    rejectSuccessTitle: 'Documento reprovado',
    rejectErrorMessage: 'Erro ao reprovar documento. Tente novamente',
    listTabType: DocumentType.DOCUMENT,
  },
  [DocumentType.REGISTRATION]: {
    cardTitle: 'Registro para Verificação',
    codeFieldLabel: 'Registro',
    usesRegistrationCard: true,
    viewButtonLabel: 'Ver registro',
    approveOptionLabel: 'Aprovar registro',
    rejectOptionLabel: 'Reprovar registro',
    hasTrainingStep: false,
    requiresRejectionJustification: true,
    rejectPlaceholder: 'Explique o que deve ser editado no registro.',
    rejectConfirmTitle: 'Tem certeza que deseja reprovar o registro?',
    rejectSuccessTitle: 'Registro reprovado',
    rejectErrorMessage: 'Erro ao reprovar registro. Tente novamente',
    listTabType: DocumentType.REGISTRATION,
  },
};

const isDocumentType = (value: unknown): value is DocumentType =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(VERIFICATION_DETAIL_CONFIG, value);

export const getVerificationDetailConfig = (documentType?: string): VerificationDetailConfig =>
  isDocumentType(documentType)
    ? VERIFICATION_DETAIL_CONFIG[documentType]
    : VERIFICATION_DETAIL_CONFIG[DocumentType.DOCUMENT];
